/**
 * Created by Ning Jiang on 10/18/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {CreepyCarnivalTwoGameMode} from "../../gamemode/CreepyCarnivalTwoGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class CCTwoFreeSpinEntryEvents {
    public static readonly ENTER_IN_FREE_SPIN: string = "CCTwoFreeSpinEntryEvents_ENTER_IN_FREE_SPIN";
    public static readonly RESET_MULTIPLIER: string = "CCTwoFreeSpinEntryEvents_RESET_MULTIPLIER";
    public static readonly SHOW_FREE_SPIN_WON: string = "CCTwoFreeSpinEntryEvents_SHOW_FREE_SPIN_WON";
    public static readonly FRAME_ANIM_COMPLETED: string = "CCTwoFreeSpinEntryEvents_FRAME_ANIM_COMPLETED";
    public static readonly PLAY_SMOKE_ANIMATION: string = "CCTwoFreeSpinEntryEvents_PLAY_SMOKE_ANIMATION";
    public static readonly SCATTER_WIGGLE_ANIM: string = "CCTwoFreeSpinEntryEvents_SCATTER_WIGGLE_ANIM";
    public static readonly KILL_FREE_GAME_BULBS: string = "CCTwoFreeSpinEntryEvents_KILL_FREE_GAME_BULBS";
}

export class CreepyCarnivalTwoFreespinIntroController extends FreespinIntroController {

    constructor(config: IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data: ParsedServerData): boolean {
        return super.calculateIsTriggered(data) && (data.nextMode === GameMode.FREESPIN || data.nextMode === CreepyCarnivalTwoGameMode.RESPIN_FREESPIN) && (data.mode !== CreepyCarnivalTwoGameMode.RESPIN_FREESPIN);
    }

    protected onCloseComplete(): void {
        EventHandler.dispatchEvent(new GameEvent(CCTwoFreeSpinEntryEvents.ENTER_IN_FREE_SPIN));
        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
        super.onCloseComplete();
        //   EventHandler.dispatchEvent(new GameEvent(TombstoneMultiplierController.SHOW_END_MULTIPLIER, true));
    }
}